import { Button, Typography, Box } from '@mui/material';

export const YesNoNASelector = ({ label, name, onChange, value }) => {
  const options = ['Y', 'N', 'NA'];

  return (
    <Box mb={3} width="100%">
      <Typography variant="subtitle1" gutterBottom>{label}</Typography>

      {/* Forzar que todo ocupe 100% y los botones se distribuyan */}
      <Box display="flex" gap={2} width="100%">
        {options.map((option) => (
          <Button
            key={option}
            onClick={() => onChange(name, option)}
            variant={value === option ? 'contained' : 'outlined'}
            sx={{
              flex: 1, // que todos ocupen el mismo ancho
              backgroundColor: value === option ? '#1976d2' : 'white',
              color: value === option ? 'white' : 'black',
              borderColor: '#bdbdbd',
              height: '40px',
              '&:hover': {
                backgroundColor: value === option ? '#1565c0' : '#f0f0f0',
              },
            }}
          >
            <Typography>{option}</Typography>
          </Button>
        ))}
      </Box>
    </Box>
  );
};
